import { MeusTreinosProvider } from "./../meus-treinos";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CacheProvider } from "../cache/cache";

/*
  Generated class for the TrainingClassProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TrainingClassProvider {
    private treinos;
    private treinosHistory;
    private cachePath = "training";
    private cachePathHistory = "training-history";

    constructor(
        private cache: CacheProvider,
        private meusTreinos: MeusTreinosProvider
    ) {}

    get() {
        return this.treinos;
    }

    set(value) {
        this.treinos = value;
    }

    getCachePath() {
        return this.cachePath;
    }

    getCache(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.cache
                .getCache(this.cachePath)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    setCache(value): Promise<any> {
        return new Promise((resolve, reject) => {
            this.cache
                .setCache(this.cachePath, value)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    update(training): Promise<any> {
        return new Promise((resolve, reject) => {
            this.meusTreinos
                .update(training)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    setClass(user): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getCache().then((cache) => {
                this.set(cache);
                this.meusTreinos
                    .getTreinos(user)
                    .then((res) => {
                        this.set(res);
                        this.setCache(res);
                        resolve(res);
                    })
                    .catch((err) => {
                        console.warn("1", err);
                        reject(err);
                    });
            });
        });
    }

    getHistory() {
        return this.treinosHistory;
    }

    setHistory(value) {
        this.treinosHistory = value;
    }

    getCachePathHistory() {
        return this.cachePathHistory;
    }

    getCacheHistory(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.cache
                .getCache(this.cachePathHistory)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    setCacheHistory(value): Promise<any> {
        return new Promise((resolve, reject) => {
            this.cache
                .setCache(this.cachePathHistory, value)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    setClassHistory(user): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getCacheHistory().then((res) => {
                this.setHistory(res);
                this.meusTreinos
                    .getHistorico(user)
                    .then((res) => {
                        this.setHistory(res);
                        this.setCacheHistory(res);
                        resolve(true);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/training-class/training-class.ts